import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { TranslateService, TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [CommonModule, FormsModule, RouterModule, TranslateModule],
  templateUrl: './home.component.html',
  styleUrl: './home.component.css'
})
export class HomeComponent implements OnInit {
  showCookieToast = false;
  trackingCode = '';

  constructor(
    private translate: TranslateService,
    private router: Router
  ) {}

  ngOnInit(): void {
    const cookiesAccepted = localStorage.getItem('cookiesAccepted');
    if (cookiesAccepted !== 'true') {
      this.showCookieToast = true;
    }
  }

  acceptCookies(): void {
    this.showCookieToast = false;
    localStorage.setItem('cookiesAccepted', 'true');
  }

  goToTracking(): void {
    const code = this.trackingCode.trim();
    if (code) {
      this.router.navigate(['/tracking', code]);
    } else {
      this.router.navigate(['/tracking']);
    }
  }

  changeLanguage(lang: string): void {
    this.translate.setDefaultLang(lang);
    this.translate.use(lang);
    localStorage.setItem('language', lang);
  }
}
